import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // <-- add useNavigate
import { db } from '../../firebase';
import { doc, getDoc } from '@firebase/firestore';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import './tournaments_page.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function TournamentDetailPage() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tournament, setTournament] = useState(null);

  const toggle = () => setIsOpen(!isOpen);

  const query = useQuery();
  const tournamentId = query.toString().replace('?', '').replace('=', '');

  const navigate = useNavigate(); // <-- add this

  useEffect(() => {
    async function fetchTournament() {
      setLoading(true);
      console.log('Fetching tournament with ID:', tournamentId);
      if (!tournamentId) return;
      const docRef = doc(db, "tournaments", tournamentId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setTournament(docSnap.data());
      }
      setLoading(false);
    }
    fetchTournament();
  }, [tournamentId]);

  if (loading) {
    return (
      <div className="tournaments-bg">
        <div className="tournaments-card">
          <div className="admin-login-loading">
            <div className="admin-login-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!tournament) {
    return (
      <div className="tournaments-bg">
        <div className="tournaments-card">
          <h2 className="tournaments-title">Tournament Not Found</h2>
        </div>
      </div>
    );
  }

  // Helper to join arrays nicely
  const join = arr => Array.isArray(arr) ? arr.join(', ') : arr || '—';

  return (
    <>
      <Sidebar isopen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} darkMode={true} />
      <div className="tournaments-bg">
        <div className="tournaments-card" style={{ maxWidth: 700 }}>
          <button
            className="tournament-back-btn"
            onClick={() => navigate('/tournaments')}
          >
            <span style={{ fontSize: '1.2rem', marginRight: '0.4rem' }}>←</span>
            Back
          </button>
          <h1 className="tournaments-title" style={{ marginBottom: '1.2rem' }}>
            {tournament.tournamentName}
          </h1>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Location:</div>
            <div>{join(tournament.cities)}, {join(tournament.states)}, {join(tournament.countries)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Type:</div>
            <div>{join(tournament.tournamentTypes)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Association:</div>
            <div>{join(tournament.tournamentAssociations)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Course:</div>
            <div>{join(tournament.golfCourses)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Start Date:</div>
            <div>{tournament.startDate || '—'}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">End Date:</div>
            <div>{tournament.endDate || '—'}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Tournament Web Page:</div>
            <div>
              {tournament.tournamentPage ? (
                <a href={tournament.tournamentPage} target="_blank" rel="noopener noreferrer">
                  {tournament.tournamentPage}
                </a>
              ) : '—'}
            </div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Qualifier Needed:</div>
            <div>{tournament.qualifierNeeded ? 'Yes' : 'No'}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Other Sites:</div>
            <div>{join(tournament.otherSites)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Qualifier For:</div>
            <div>{join(tournament.qualifierFor)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Qualifiers:</div>
            <div>{join(tournament.qualifiers)}</div>
          </div>
          <div className="tournament-detail-row">
            <div className="tournament-detail-label">Related Tournaments:</div>
            <div>{join(tournament.relatedTournaments)}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TournamentDetailPage;